import React from 'react';
import { Button } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import FileIcon from '@cp/assets/images/icons/FileIcon';
import DownloadIcon from '@cp/assets/images/icons/DownloadIcon';
import { getFileDownload } from '@cp/utils/commonUtils';
import CrossIcon from '@cp/assets/icons/CrossIcon';

interface ExistingFileDownloadComponentProps {
  containerClassName?: string;
  fileUrl?: string | null;
  fileName?: string;
  onRemoveFile?: () => void;
  onDownloadFile?: () => void;
}

const ExistingFileDownloadComponent: React.FC<ExistingFileDownloadComponentProps> = ({
  containerClassName,
  fileUrl,
  fileName = 'Experiment File',
  onRemoveFile,
  onDownloadFile
}) => {
  const handleDownload = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onDownloadFile) {
      onDownloadFile();
    } else if (fileUrl) {
      getFileDownload(fileUrl, true);
    }
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onRemoveFile) {
      onRemoveFile();
    }
  };

  return (
    <>
      <div
        className={cx(
          'flex items-center justify-between text-gray-600 mt-3.5 rounded-lg border border-solid border-[--blue-border] bg-[var(--blue-light-bg)] h-[40px] gap-2 p-2',
          containerClassName
        )}
      >
        <div className="flex gap-2 items-center">
          <div>
            <FileIcon width={20} height={20} />
          </div>
          <div className="max-w-[200px] text-ellipsis overflow-hidden">{fileName}</div>
        </div>
        <div className="controls flex items-center gap-1 mr-2">
          <Button variant="text" onClick={handleRemove}>
            <CrossIcon height={16} width={16} fillColor={'var(--blue-base)'} />
          </Button>
          <Button variant="text" onClick={handleDownload}>
            <DownloadIcon height={20} width={20} />
          </Button>
        </div>
      </div>
    </>
  );
};

export default ExistingFileDownloadComponent;
